import React from 'react';

export const Letter: React.FC = () => {
	return (
		<svg width="32" height="25" viewBox="0 0 32 25" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M0 20.3334V4.33337C0 2.12424 1.79086 0.333374 4 0.333374H28C30.2091 0.333374 32 2.12424 32 4.33337V20.3334C32 22.5425 30.2091 24.3334 28 24.3334H4C1.79086 24.3334 0 22.5425 0 20.3334ZM2 20.3334V4.33337C2 3.9549 2.10513 3.60097 2.28778 3.29921L14.8 12.6834C15.5111 13.2167 16.4889 13.2167 17.2 12.6834L29.7122 3.29921C29.8949 3.60097 30 3.95489 30 4.33337V20.3334C30 21.4379 29.1046 22.3334 28 22.3334H4C2.89543 22.3334 2 21.4379 2 20.3334ZM27.6667 2.33337H4.33333L16 11.0834L27.6667 2.33337Z"
				fill="#D1005D"
			/>
		</svg>
	);
};
